import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ReactComponent as Logo } from "../../../assets/images/logo.svg";
import { MenuIcon, CloseIcon } from "../../../assets/ui/icons";
import { cn } from "./cn";
import { WIDE_MEASURE } from "./measure";

/* u1 top bar. Logo on the left, whatever the screen needs on the right. The actions are a slot rather than a fixed set because each screen carries a different... */
export const Navbar = ({ actions, className = "" }) => {
  const [menuOpen, setMenuOpen] = useState(false);

  // Growing past the breakpoint shows the actions inline, so a panel left open
  // would otherwise duplicate them.
  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth >= 640) setMenuOpen(false);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return (
    <header
      className={cn(
        // Pinned on every screen: on a phone the bar is the only way back out
        // of a long form, so it must not scroll away.
        "w-full sticky top-0 z-40 bg-[var(--bg)] border-b border-[var(--line)]",
        className
      )}
    >
      {/* h-20 (80px) is the height of the global header the rest of the app renders — py-4 above and below a 48px logo. */}
      <div
        data-testid="u1-navbar-row"
        className={cn(WIDE_MEASURE, "h-20 flex items-center justify-between gap-4")}
      >
        <Link to="/" aria-label="TREVEX home" className="flex items-center shrink-0">
          {/* The mark steps down on phones; the intrinsic 48px is too heavy
              beside a 44px tap target. */}
          <Logo className="h-8 w-auto sm:h-10 md:h-12" />
        </Link>

        {actions && (
          <>
            <div className="hidden sm:flex items-center gap-3">{actions}</div>

            <button
              type="button"
              onClick={() => setMenuOpen((open) => !open)}
              aria-label={menuOpen ? "Close menu" : "Open menu"}
              aria-expanded={menuOpen}
              className="sm:hidden w-11 h-11 -mr-2 flex items-center justify-center rounded-lg text-[var(--ink)] hover:bg-[var(--slate-2)] transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--orange)]"
            >
              {menuOpen ? <CloseIcon /> : <MenuIcon />}
            </button>
          </>
        )}
      </div>

      {actions && menuOpen && (
        <div className="sm:hidden border-t border-[var(--line)] px-4 py-3 flex flex-col items-stretch gap-3 [&_a]:block [&_button]:w-full">
          {actions}
        </div>
      )}
    </header>
  );
};

export default Navbar;
